import { useEffect, useState } from "react";
import client from "../api/client";
import { useAuth } from "../context/AuthContext";
import LectorCard from "../components/lectors/LectorCard";
import LectorFormModal from "../components/lectors/LectorFormModal";
import { Loader2, Plus } from "lucide-react";

export default function Lectors() {
  const { user } = useAuth();
  const [lectors, setLectors] = useState(null);
  const [modal, setModal] = useState(null); // {lector} | {} for new
  const canManage = user?.role === "admin" || user?.role === "user";

  const load = () => client.get("/lectors").then((res) => setLectors(res.data));
  useEffect(() => { load(); }, []);

  return (
    <>
      <div className="h-16 border-b border-border px-8 flex items-center justify-between sticky top-0 bg-background/80 backdrop-blur-md z-10">
        <h1 className="font-heading text-xl font-semibold tracking-tight">Lektoři</h1>
        {canManage && (
          <button onClick={() => setModal({})} data-testid="add-lector-btn" className="h-9 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 flex items-center gap-1.5">
            <Plus className="h-4 w-4" /> Nový lektor
          </button>
        )}
      </div>
      <div className="p-8">
        {!lectors ? (
          <div className="text-sm text-muted-foreground flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" /> Načítání…</div>
        ) : lectors.length === 0 ? (
          <div className="text-sm text-muted-foreground">Zatím žádní lektoři. Přidejte prvního tlačítkem „Nový lektor".</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="lectors-grid">
            {lectors.map((l) => (
              <LectorCard key={l.id} lector={l} onEdit={canManage ? (lec) => setModal({ lector: lec }) : null} />
            ))}
          </div>
        )}
      </div>

      {modal && (
        <LectorFormModal
          lector={modal.lector}
          onClose={() => setModal(null)}
          onSaved={() => { setModal(null); load(); }}
        />
      )}
    </>
  );
}
